<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ExclamationIcon from "@/customIcons/exclamationIcon";
import appConfig from "@/app.config";
import { Order, Address } from "@/services/westore/entities";

import { channels } from "@/mixins/channels";
import FormSkeleton from "../../../components/skeletons/form-skeleton.vue";
import { Download } from "@/mixins/download";
import CancelOrderModal from "../../../components/cancelOrderModal.vue";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  mixins: [channels, Download],
  page: {
    title: "Order Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    FormSkeleton,
    CancelOrderModal,
    ExclamationIcon,
  },
  props: {
    rowData: {
      type: Object,
    },
  },
  data() {
    return {
      title: this.$t("Order Details"),
      itemDetails: {},
      loaded: false,
      showContentLoader: false,
      showReturnElement: false,
      isMessage: false,
      successMessage: "",
      returnProducts: [],
      demoPage: false,
      dialog: false,
      restrictedStatusForCancel: [
        "RTO",
        "Picked up for return",
        "Delivered",
        "Cancelled",
      ],
      cancelReasons: [
        "Customer wants to cancel the order",
        "I will submit another order",
        "Order created by mistake",
      ],
      cancelReason: "",
      loader: false,
      formInputs: { country_id: null, city_id: null, details: null },
      countries: [],
      cities: [],
      submitted: false,
    };
  },
  validations: {
    formInputs: {
      city_id: {
        required,
      },
      country_id: {
        required,
      },
      details: {
        required,
      },
    },
  },
  watch: {
    async ["formInputs.country_id"](val) {
      const { data: cities } = await Order.getCities(val);
      this.cities = cities;
      this.formInputs.city_id = this.cities[0]?.id;
    },
  },
  async created() {
    if (!this.rowData) {
      await this.fetchDetails();
      this.fetchOptions();
    } else {
      this.itemDetails = this.rowData;
      this.returnProducts = this.itemDetails?.products;
    }
  },
  methods: {
    async fetchDetails() {
      this.loaded = false;
      this.showContentLoader = true;

      await Order.getOne(this.$route.params?.id)
        .then((res) => {
          this.itemDetails = res.data;
          this.formInputs.details = this.itemDetails?.address?.details;
          this.returnProducts = this.itemDetails?.products;
        })
        .finally(() => {
          this.loaded = true;
          this.showContentLoader = false;
        });
    },

    async cancelOrder() {
      this.loader = true;
      try {
        await Order.cancel(this.itemDetails?.id, {
          reason: this.cancelReason,
        });

        this.$toast.success(
          `Order #${this.itemDetails.order_number} is now canceled!`
        );
        this.fetchDetails();
      } catch (error) {
        this.$toast.error("Something went wrong, please try again later");
      } finally {
        this.loader = false;
        this.dialog = false;
      }
    },
    createOrderReturn() {
      if (this.returnProducts.length === 0) {
        return;
      }

      this.$router.push({
        name: "order-return-create",
        query: {
          ...this.itemDetails,
          products: this.returnProducts,
        },
      });
    },
    toggleOrderPage() {
      this.demoPage = !this.demoPage;
    },
    async downloadFile(id, path) {
      let extension = "pdf";
      const data = await Order.blobResponse().getFile(id, path);

      const type = Order.getHeader("content-type");
      const filename = `order_${path}_${new Date().getTime()}.${extension}`;
      this.download(data, type, filename);
    },
    handleLinkClick(url) {
      url ? window.open(url, "_blank") : null;
    },
    async fetchOptions() {
      if (this.itemDetails.status !== "On Hold") return;
      const { data: options } = await Order.getOptions();
      this.paymentTerms = options.payment_methods;
      this.deliverySpeedTypes = options.delivery_speed;
      const { data: countries } = await Order.getCountries();

      this.countries = countries;
      this.formInputs.country_id = this.userCountry.id;
      const { data: cities } = await Order.getCities(this.userCountry.id);
      this.cities = cities;

      return Promise.resolve();
    },
    resetForm() {
      this.formInputs = { country_id: null, city_id: null, address: null };
    },
    async updateOrderAddress() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      try {
        await Address.update(this.formInputs, this.itemDetails?.address?.id);

        await Order.updateStatus({ status: "1" }, this.itemDetails?.id);

        this.fetchDetails();
        this.fetchOptions();
        this.$toast.success(
          `Order #${this.itemDetails?.order_number} has changed from On-Hold to Initiated`
        );
      } catch ({ response }) {
        this.$toast.error(response.data.message);
      }

      console.log("first");
    },
    renderCauser(causer) {
      if (causer.includes(this.user.first_name)) {
        return "You";
      } else {
        return causer;
      }
    },
    renderLogColor(status) {
      switch (status) {
        case "Cancelled":
          return "danger";
        case "Success":
          return "success";
        case "On Hold":
          return "warning";
        case "Processing":
        case "Initiated":
          return "info";
        default:
          return "primary";
      }
    },
  },
  computed: {
    ...mapGetters({
      userCountry: ["auth/userCountry"],
      user: ["auth/userInfo"],
    }),
    calculateSubTotal() {
      return this.testProducts.reduce((acc, { unitPrice, quantity }) => {
        return acc + unitPrice * quantity;
      }, 0);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" class="d-print-none">
      <!-- <b-button
        type="submit"
        variant="primary"
        class="btn-block"
        size="md"
        @click="toggleOrderPage"
        >Demo</b-button
      > -->
    </PageHeader>
    <!-- <v-row v-if="demoPage">
      <v-col cols="12" sm="12" xs="12" lg="6" md="12">
        <v-card elevation="2" height="100%" class="p-3">
          <h4 class="card-title mb-4">Summary</h4>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" class="text-center"
                >Total amount: {{ itemDetails.total | currency }}
              </v-col>
              <v-col cols="12" class="text-center">
                Creation date: {{ convertDate(itemDetails.created) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col md="5" offset-md="0"
                >Order status: {{ itemDetails.status }}</v-col
              >
              <v-col md="7">Payment: {{ itemDetails.payment_method }}</v-col>
            </v-row>
            <v-row>
              <v-col md="5" offset-md="1" class="d-flex"
                ><span>Channel</span>
                <v-img
                  :src="detectChannel(itemDetails.marketplace)"
                  contain
                  height="25"
                  width="25"
              /></v-col>
              <v-col cols="6"
                >Delivery speed: {{ itemDetails.delivery_speed.title }}</v-col
              >
            </v-row>
          </v-card-text></v-card
        >
      </v-col>
      <v-col cols="12" sm="12" xs="12" lg="6" md="12">
        <v-card elevation="2" class="p-3" height="100%">
          <h4 class="card-title mb-2">Customer information</h4>
          <div class="card">
            <div class="card-body">
              <div>
                <div>
                  <h5>{{ itemDetails.recipient.name }}</h5>
                  <p class="text-muted mb-0">
                    {{ itemDetails.recipient.email }}
                  </p>
                  <p class="text-muted mb-0">
                    {{ itemDetails.recipient.phone }}
                  </p>

                  <p class="text-muted mb-0">
                    {{ itemDetails.address.details }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" xs="12" lg="12" md="12">
        <v-card elevation="2" height="100%" class="p-3">
          <h4 class="card-title mb-4">Order Summary</h4>

          <div class="table-responsive">
            <table class="table align-middle mb-0 table-nowrap">
              <thead class="table-light">
                <tr>
                  <th scope="col">Product</th>
                  <th scope="col">Product Desc</th>
                  <th scope="col">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(product, index) in itemDetails.products"
                  :key="index"
                >
                  <td scope="row">
                    <img
                      :src="detectChannel(itemDetails.marketplace)"
                      alt="product-img"
                      title="product-img"
                      class="table-avatar"
                    />
                  </td>
                  <td class="py-7">
                    <h5 class="font-size-14 text-truncate text-dark">
                      {{ product.name }}
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      {{ product.amount | currency }}
                    </h5>
                    <p class="text-muted mb-0">
                      {{ product.price | currency }} X {{ product.quantity }}
                    </p>
                  </td>
                </tr>

                <tr>
                  <td colspan="2">
                    <h6 class="m-0 text-end">Sub Total :</h6>
                  </td>
                  <td>{{ itemDetails.sub_total | currency }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h6 class="m-0 text-end">Discount :</h6>
                  </td>
                  <td>
                    {{
                      itemDetails.discount ? itemDetails.discount : 0 | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h6 class="m-0 text-end">VAT :</h6>
                  </td>
                  <td>
                    {{ itemDetails.tax ? itemDetails.tax : 0 | currency }}
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <div class="bg-info bg-primary p-3 rounded">
                      <h5 class="font-size-14 text-primary mb-0">
                        <i class="fas fa-shipping-fast me-2"></i>
                        Shipping
                        <span class="float-end">Free</span>
                      </h5>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h6 class="m-0 text-end">Total:</h6>
                  </td>
                  <td>{{ itemDetails.total | currency }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card>

        <div class="row mt-4">
          <div class="col-sm-6">
            <router-link
              to="/ecommerce/cart"
              class="btn text-muted d-none d-sm-inline-block btn-link"
            >
              <i class="mdi mdi-arrow-left me-1"></i> Back to Shopping Cart
            </router-link>
          </div>

          <div class="col-sm-6">
            <div class="text-end">
              <router-link to="/ecommerce/checkout" class="btn btn-success">
                <i class="mdi mdi-truck-fast me-1"></i> Proceed to Shipping
              </router-link>
            </div>
          </div>
        </div>
      </v-col>
       <v-col cols="12" sm="12" xs="12" lg="6" md="12">
        <v-card
          elevation="2"
          height="100%"
          class="d-flex justify-center align-center p-3"
        >
          <img
            :src="require(`@/assets/images/test-airwaybill.png`)"
            alt="product-img"
            title="product-img"
            class="w-100 h-25"
          />

          <h4 class="card-title mb-4">Airway Bill</h4>
        </v-card>
      </v-col>
    </v-row> -->
    <div class="pt-5">
      <FormSkeleton v-if="showContentLoader" />
      <v-spacer />
      <div class="card">
        <div
          class="card-body"
          v-if="showContentLoader === false && loaded && itemDetails !== null"
        >
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-4 p-2">
              <span
                >{{ $t("Order") }}
                <code class="pink--text"
                  >#{{ this.itemDetails.order_number }}</code
                ></span
              >
              <div class="mb-4 float-end hide-from-screen">
                <img
                  src="@/assets/images/logo-dark.png"
                  alt="logo"
                  height="20"
                />
              </div>
            </h4>

            <div v-if="itemDetails.has_attachments">
              <b-button
                type="submit"
                variant="white"
                class="btn-block mr-2 btn-outline-info"
                size="md"
                @click="handleLinkClick(itemDetails.tracking_url)"
              >
                Tracking Link
                <i class="fas fa-paperclip font-size-15 ml-1"></i>
              </b-button>
              <b-button
                type="submit"
                variant="info"
                class="btn-block mr-2"
                size="md"
                @click="downloadFile(itemDetails.id, 'invoice')"
              >
                Dwonload Invoice
                <v-icon size="17" class="mb-1 ml-1"
                  >$vuetify.icons.whiteDownload</v-icon
                >
              </b-button>
              <b-button
                type="submit"
                variant="primary"
                class="btn-block mr-2"
                size="md"
                @click="downloadFile(itemDetails.id, 'awb')"
              >
                Download AWB
                <v-icon size="17" class="mb-1 ml-1"
                  >$vuetify.icons.whiteDownload</v-icon
                >
              </b-button>
            </div>
          </div>
          <div class="card p-2" v-if="itemDetails.status === 'On Hold'">
            <div class="d-flex justify-content-between align-center">
              <div class="text-warning font-size-18 fw-smibold">
                Missing Address Input
              </div>
              <div
                class="rounded-xl font-size-14 py-2 px-4 bg-warning text-white"
              >
                On-Hold
              </div>
            </div>
            <div class="d-flex align-center">
              <ExclamationIcon :disabled="true" class="mr-2" />
              <span class="note font-size-14"
                >Please keep in mind that; this order will be On-Hold till you
                fill in the missing fields below .</span
              >
            </div>
            <div class="border-top border-warning w-50 mt-3" />
            <div class="w-75">
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Customer Country</label>
                </b-col>
                <b-col sm="4">
                  <b-form-select
                    v-model="formInputs.country_id"
                    class="form-select"
                    value-field="id"
                    text-field="name"
                    :options="countries"
                    type="text"
                    :class="{
                      'is-invalid': submitted && $v.formInputs.city_id.$error,
                    }"
                  ></b-form-select>
                </b-col>
                <b-col sm="2">
                  <label for="input-small">Customer City/Area</label>
                </b-col>
                <b-col sm="4">
                  <b-form-select
                    v-model="formInputs.city_id"
                    class="form-select"
                    value-field="id"
                    text-field="name"
                    :options="cities"
                    type="text"
                    :class="{
                      'is-invalid': submitted && $v.formInputs.city_id.$error,
                    }"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Customer Address:</label>
                </b-col>
                <b-col>
                  <b-form-textarea
                    id="textarea"
                    v-model="formInputs.details"
                    type="textarea"
                    :class="{
                      'is-invalid': submitted && $v.formInputs.details.$error,
                    }"
                  ></b-form-textarea>
                </b-col>
              </b-row>
            </div>
            <div class="d-flex justify-content-end align-center my-3">
              <v-btn class="mr-3" small @click="resetForm"
                >Cancel Changes</v-btn
              >
              <v-btn color="primary" small @click="updateOrderAddress"
                >Save & Continue</v-btn
              >
            </div>
          </div>
          <!-- Details -->
          <div class="table-responsive">
            <table class="table table-nowrap mb-0">
              <tbody>
                <tr>
                  <th scope="row">{{ $t("CREATED AT") }}</th>
                  <td>{{ convertDate(itemDetails.created) }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Status") }}</th>
                  <td class="d-flex align-center">
                    <span
                      class="badge"
                      :class="detectStatus(itemDetails.status)"
                      >{{ itemDetails.status }}
                    </span>
                    <span
                      v-if="itemDetails.status_comment"
                      class="cancel__reason-box"
                    >
                      <v-icon size="16" class="mr-2"
                        >$vuetify.icons.chat</v-icon
                      >
                      <span class="cancel__reason-box__reason">{{
                        itemDetails.status_comment
                      }}</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("RECIPIENT NAME") }}</th>
                  <td>{{ this.itemDetails.recipient.name }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("RECIPIENT EMAIL") }}</th>
                  <td>{{ this.itemDetails.recipient.email }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("RECIPIENT PHONE") }}</th>
                  <td>{{ this.itemDetails.recipient.phone }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("RECIPIENT CITY/AREA") }}</th>
                  <td>{{ this.itemDetails.city.name }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("RECIPIENT ADDRESS") }}</th>
                  <td>
                    {{ this.itemDetails.recipient.default_address.details }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("PAYMENT TERM") }}</th>
                  <td>{{ this.itemDetails.payment_method }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Delivery Speed") }}</th>
                  <td>{{ this.itemDetails.delivery_speed }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Order Items") }}</th>
                  <td>
                    <div class="col-xl d-print-none">
                      <div class="d-flex">
                        <button
                          type="button"
                          class="btn btn-danger mr-1"
                          @click="dialog = true"
                          v-if="
                            !restrictedStatusForCancel.includes(
                              itemDetails.status
                            )
                          "
                        >
                          {{ $t("Cancel") }}
                        </button>

                        <button
                          type="button"
                          class="btn btn-warning"
                          v-else-if="
                            itemDetails.status === 'Shipped' &&
                            showReturnElement === false
                          "
                          @click="showReturnElement = true"
                        >
                          Initiate Return
                        </button>
                        <button
                          v-else-if="itemDetails.status === 'Delivered'"
                          type="button"
                          class="btn btn-warning mr-1"
                          @click="
                            $router.push({
                              name: 'order-return-create',
                              query: itemDetails,
                            })
                          "
                        >
                          {{ $t("Return Order") }}
                        </button>
                      </div>
                    </div>
                    <table class="table table-striped mb-0 border">
                      <thead>
                        <tr>
                          <th scope="col" v-if="showReturnElement">#</th>
                          <th scope="col">{{ $t("SKU") }}</th>
                          <th scope="col">{{ $t("PRODUCT NAME") }}</th>
                          <th scope="col">{{ $t("Weight (gram)") }}</th>
                          <th scope="col">{{ $t("UNIT PRICE (AED)") }}</th>
                          <th scope="col">{{ $t("QUANTITY") }}</th>
                          <th scope="col">{{ $t("Total Per Item") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in itemDetails.products"
                          :key="index"
                        >
                          <td v-if="showReturnElement">
                            <input
                              type="checkbox"
                              v-model="returnProducts"
                              :value="item"
                            />
                          </td>
                          <td>{{ item.sku }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.weight ? item.weight : "-" }}</td>
                          <td>{{ item.price }}</td>
                          <td>{{ item.quantity }}</td>
                          <td>{{ item.amount }}</td>
                        </tr>
                        <tr>
                          <th colspan="5">{{ $t("Total") }}</th>
                          <td>
                            <span class="badge badge-soft-info">{{
                              this.itemDetails.total
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="mt-6">
                      <div
                        class="d-flex align-center justify-content-between mb-4"
                      >
                        <div class="fw-bold font-size-16">
                          Order’s history log
                        </div>
                        <div>
                          Order created:
                          <span class="text-primary ml-1"
                            ><b>{{ convertDate(itemDetails.created) }}</b>
                          </span>
                        </div>
                      </div>
                      <div class="border border-1 border-grey p-2 rounded">
                        <div
                          v-for="(
                            { created, current_status, causer }, i
                          ) in itemDetails.status_logs"
                          class="log-box d-flex rounded mb-3"
                          :key="i"
                        >
                          <div
                            class="log-bg rounded align-self-stretch"
                            :class="
                              ['On Hold', 'Cancelled', 'Success'].includes(
                                current_status
                              )
                                ? `bg-${renderLogColor(current_status)}`
                                : `bg-${renderLogColor('default')}`
                            "
                          ></div>
                          <div
                            class="grow d-flex align-center justify-content-between py-4"
                          >
                            <div
                              class="py-2 px-5 border border-1 rounded-xl mx-4"
                              :class="
                                ['On Hold', 'Cancelled', 'Success'].includes(
                                  current_status
                                )
                                  ? `border-${renderLogColor(
                                      current_status
                                    )} text-${renderLogColor(current_status)}`
                                  : `border-${renderLogColor(
                                      'default'
                                    )} text-${renderLogColor('default')}`
                              "
                            >
                              {{ convertDate(created, "DD MMM") }} -
                              {{ convertDate(created, "hh:mm a") }}
                            </div>
                            <div
                              class="border-top grow"
                              :class="`border-${renderLogColor(
                                current_status
                              )}`"
                            ></div>
                            <div class="mx-4 font-size-16">
                              <span class="text-primary">Status Update: </span>
                              <span
                                :class="`text-${renderLogColor(
                                  current_status
                                )}`"
                                >{{ current_status }}</span
                              >
                            </div>
                            <div
                              class="border-top grow"
                              :class="`border-${renderLogColor(
                                current_status
                              )}`"
                            ></div>
                            <div class="mx-4 font-size-16 d-flex align-center">
                              <span class="log-action mr-1">Action by: </span
                              ><span v-if="causer.includes(user.first_name)">{{
                                "You"
                              }}</span>
                              <v-img
                                v-else
                                class="mx-auto"
                                :src="detectChannel(causer)"
                                height="35"
                                contain
                                width="80"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="log-box d-flex rounded">
                          <div
                            class="bg-primary log-bg rounded align-self-stretch"
                          ></div>
                          <div
                            class="grow d-flex align-center justify-content-between py-4"
                          >
                            <div
                              class="py-2 px-5 border border-1 border-primary rounded-xl mx-4"
                            >
                              {{ convertDate(itemDetails.created, "DD MMM") }} -
                              {{ convertDate(itemDetails.created, "hh:mm a ") }}
                            </div>
                            <div class="border-top border-info grow"></div>
                            <div class="mx-4 font-size-16">
                              <span class="text-primary">Status Update: </span>
                              <span class="text-info">Initiated</span>
                            </div>
                            <div class="border-top border-info grow"></div>
                            <div class="mx-4 font-size-16">
                              <span class="log-action">Action by: </span
                              ><span>You</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl d-print-none">
                      <div class="d-flex">
                        <button
                          type="button"
                          class="btn btn-danger mr-1"
                          @click="showReturnElement = false"
                          v-if="showReturnElement"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          class="btn btn-info"
                          v-if="showReturnElement"
                          @click="createOrderReturn()"
                          v-bind:disabled="returnProducts.length === 0"
                        >
                          Create Return
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Back and get support buttons -->
          <div class="d-flex align-items-center mt-4 d-print-none">
            <router-link :to="{ name: 'support-tickets-list' }">
              <b-btn class="btn btn-info">
                <i class="bx bx-arrow-back"></i> Back</b-btn
              >
            </router-link>
            <div class="">
              <a
                href="javascript:window.print()"
                :class="isRtl ? 'btn btn-success mr-2' : 'btn btn-success ml-2'"
                ><i class="fa fa-print text-white"></i
              ></a>
              <router-link :to="{ name: 'get-support' }">
                <b-btn
                  :class="
                    isRtl
                      ? 'btn btn-warning float-end mr-2'
                      : 'btn btn-warning float-end ml-2'
                  "
                  ><i class="bx bx-support"></i> Get Support</b-btn
                >
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar
      color="success accent-2"
      elavation="24"
      top
      right
      v-model="isMessage"
    >
      {{ successMessage }}
    </v-snackbar>
    <CancelOrderModal
      :dialog="dialog"
      @close="
        dialog = false;
        cancelReason = '';
      "
    >
      <div class="card-body px-0 pb-0 text-center">
        <div class="d-flex flex-column align-items-center">
          <v-icon color="primary" size="30">$vuetify.icons.questionMark</v-icon>
        </div>
        <div class="d-flex flex-column mt-10 mb-6 px-16">
          <div class="flex-grow-1">
            <div class="card-subtitle text-primary font-size-20 fw-bold">
              Are you sure to cancel this order
              <span class="text-info"># {{ itemDetails.order_number }}</span> ?
            </div>
          </div>
          <div class="text-center my-6">
            <div class="cancel-box text-primary font-size-18 fw-smibold">
              Cancellation fees may be applied!
            </div>
          </div>

          <p
            class="card-subtitle text-primary text-center mb-3 font-size-14 fw-smibold"
          >
            <span class="text-danger d-block">Why?</span> Fees may apply if the
            order is being fully / partially processed by Warehouse or delivery
            company
          </p>
          <b-form-select
            v-model="cancelReason"
            class="form-select"
            value-field="id"
            text-field="name"
            :options="cancelReasons"
            type="text"
          ></b-form-select>
        </div>

        <div class="btn-box">
          <v-row>
            <v-col cols="6">
              <v-btn
                color="grey_light"
                block
                @click="
                  dialog = false;
                  cancelReason = '';
                "
              >
                <span class="text-white text-capitalize">No</span></v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn
                color="danger_light"
                block
                :disabled="!cancelReason"
                @click="cancelOrder"
              >
                <v-progress-circular
                  v-if="loader"
                  :size="27"
                  :width="2"
                  color="white"
                  indeterminate
                ></v-progress-circular>
                <span v-else class="text-white text-capitalize"
                  >Yes, Cancel</span
                ></v-btn
              ></v-col
            >
          </v-row>
        </div>
      </div>
    </CancelOrderModal>
  </Layout>
</template>
<style lang="scss" scoped>
.table-avatar {
  height: 30px;
}
@media screen {
  .hide-from-screen {
    display: none;
  }
}
.cancel-box {
  background-color: #f2e5ea;
  padding: 11px 24px;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
}
.btn-box {
  background: rgba(217, 5, 5, 0.04);
  padding: 8px 10px 14px 10px;
  overflow: hidden;
}
.cancel__reason-box {
  border-radius: 8px;
  border: 1px solid #ea352b;
  padding: 3.5px 10px;
  margin-inline-start: 5px;
  &__reason {
    color: #7f8b96;
    font-size: 14px;
    font-weight: 400;
  }
}
.note {
  color: #9aa5b0;
}
.log-box {
  background-color: #eff1f2;
}
.log-action {
  color: #9aa5b0;
}
.log-bg {
  width: 10px;
}
</style>
